package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_03_22_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Zolnur tells the heroes that they should follow the border toward Tenton, at which point he will part to take care of other business. The heroes see patrols from the nearby kingdoms of Ninesh and Kastan. The heroes pass a shrine to Toramokan.")
    }
}
